import { PERSISTED_SLICES, pickPersisted } from '../settingsPersistenceConfig';
import { hydrate as hydrateFixSettings } from '../slices/fixSettingsSlice';
import { hydrate as hydrateOrganizerSettings } from '../slices/organizerSettingsSlice';
import { hydrate as hydrateFixMetadata } from '../slices/fixMetadataSlice';
import { hydrate as hydrateLoudnessSettings } from '../slices/loudnessSettingsSlice';
import { hydrate as hydrateAutomixSettings } from '../slices/automixSettingsSlice';

// Slice name -> its hydrate action creator. Keyed the same as PERSISTED_SLICES.
const HYDRATORS = {
    fixSettings: hydrateFixSettings,
    organizerSettings: hydrateOrganizerSettings,
    fixMetadata: hydrateFixMetadata,
    loudnessSettings: hydrateLoudnessSettings,
    automixSettings: hydrateAutomixSettings,
};

// Load persisted per-tab settings from localStorage into their slices at
// startup. Mirrors loadLoudnessSettings / loadCuePointsSettings — dispatch once
// from App.js init. Only the whitelisted preference keys are re-applied, so a
// stale saved blob can never resurrect transient state or unknown fields.
export const loadTabSettings = () => (dispatch) => {
    for (const [name, cfg] of Object.entries(PERSISTED_SLICES)) {
        try {
            const raw = localStorage.getItem(cfg.storageKey);
            if (!raw) continue;
            const saved = pickPersisted(JSON.parse(raw), cfg.keys);
            if (Object.keys(saved).length) dispatch(HYDRATORS[name](saved));
        } catch (e) {
            // Corrupt/missing entry — the slice's defaults stand.
        }
    }
};
